import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import { handleResponseCode } from "../../app/utilities/helpers";
import GetProxy from "../../app/GetProxy";


const proxy = GetProxy();
const cookies = new Cookies();

// Role Mapping APIs
export const rolemappingListAPI = createAsyncThunk(
  "post/rolemappingListAPI",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
      const { payload, pageLimit, pageNo } = props;
      const response = await fetch(
        `${proxy}/api/v1/roleMapping/getRoleMappingList/${pageNo}/${pageLimit}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const rolemappingCountAPI = createAsyncThunk(
  "post/rolemappingCountAPI",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
      const { payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/roleMapping/getRoleMappingListCount`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const rolemappingEdit = createAsyncThunk(
  "post/rolemappingEdit",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
      const { payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/roleMapping/saveOrUpdateRoleMapping`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const rolemappingTest = createAsyncThunk(
  "post/rolemappingTest",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
      const { payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/directory/testConnectionForGroups`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const rolemappingSave = createAsyncThunk(
  "post/rolemappingSave",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
      const { payload } = props;
      const response = await fetch(
        `${proxy}/api/v1/directory/fetchUsersByGroups`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();
      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

export const userManagementListAPI = createAsyncThunk(
  "post/userManagementListAPI",
  async (props) => {
    const Apitoken = cookies.get("apitoken");
    const User = cookies.get("username");
    try {
      const { payload, pageLimit, pageNo } = props;
      const response = await fetch(
        `${proxy}/userManagement/detailsList/${pageNo}/${pageLimit}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "DTOP-API-TOKEN": Apitoken,
            USERNAME: User,
          },
          body: JSON.stringify(payload),
        }
      );
      handleResponseCode(response);
      const data = await response.json();

      return response.ok ? data : Promise.reject(data);
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
);

const configurationSlice = createSlice({
  name: "configuration",
  initialState: {
    toolsPlugin: [],
    toolName: [],
    userManagementLoadPage: false,
    userManagementListData: [],
    userManagementListDataLoading: false,
    error : false,
    // Role Mapping
    rolemappingData: [],
    rolemappingLoader: false,
    rolemappingcountData: 0,
    rolemappingcountLoader: false,
    rolemappingtestData: {},
    rolemappingtestLoader: false,
    rolemappingeditData: {},
    rolemappingeditLoader: false,
    rolemappingsaveData: {},
    rolemappingsaveLoader: false,
  },
  reducers: {
    setToolsPlugin: {
      reducer(state, action) {
        state.toolsPlugin = action.payload;
      },
    },
    setToolsName: {
      reducer(state, action) {
        state.toolName = action.payload;
      },
    },
    setUserManagement: {
      reducer(state, action) {
        state.userManagementLoadPage = action.payload;
      },
    },
    setErrorAlert: {
      reducer(state, action) {
        state.error = false;
      },
    },
  },

  extraReducers: (builder) => {
    builder
      //userManagementListAPI
      .addCase(userManagementListAPI.pending, (state, action) => {
        state.userManagementListDataLoading = true;
        state.error = false;
      })
      .addCase(userManagementListAPI.fulfilled, (state, action) => {
        state.userManagementListDataLoading = false;
        state.userManagementListData = action.payload;
        state.error = false;
      })
      .addCase(userManagementListAPI.rejected, (state, action) => {
        state.userManagementListDataLoading = false;
        state.error = true;
      })
      // Role Mapping List
      .addCase(rolemappingListAPI.pending, (state) => {
        state.rolemappingLoader = true;
      })
      .addCase(rolemappingListAPI.fulfilled, (state, action) => {
        state.rolemappingLoader = false;
        state.rolemappingData = action.payload;
      })
      .addCase(rolemappingListAPI.rejected, (state) => {
        state.rolemappingLoader = false;
      })
      // Role Mapping Count
      .addCase(rolemappingCountAPI.pending, (state) => {
        state.rolemappingcountLoader = true;
      })
      .addCase(rolemappingCountAPI.fulfilled, (state, action) => {
        state.rolemappingcountLoader = false;
        state.rolemappingcountData = action.payload;
      })
      .addCase(rolemappingCountAPI.rejected, (state) => {
        state.rolemappingcountLoader = false;
      })
      // Role Mapping Edit
      .addCase(rolemappingEdit.pending, (state) => {
        state.rolemappingeditLoader = true;
      })
      .addCase(rolemappingEdit.fulfilled, (state, action) => {
        state.rolemappingeditLoader = false;
        state.rolemappingeditData = action.payload;
      })
      .addCase(rolemappingEdit.rejected, (state) => {
        state.rolemappingeditLoader = false;
      })
      // Role Mapping Test
      .addCase(rolemappingTest.pending, (state) => {
        state.rolemappingtestLoader = true;
      })
      .addCase(rolemappingTest.fulfilled, (state, action) => {
        state.rolemappingtestLoader = false;
        state.rolemappingtestData = action.payload;
      })
      .addCase(rolemappingTest.rejected, (state) => {
        state.rolemappingtestLoader = false;
      })
      // Role Mapping Save
      .addCase(rolemappingSave.pending, (state) => {
        state.rolemappingsaveLoader = true;
      })
      .addCase(rolemappingSave.fulfilled, (state, action) => {
        state.rolemappingsaveLoader = false;
        state.rolemappingsaveData = action.payload;
      })
      .addCase(rolemappingSave.rejected, (state) => {
        state.rolemappingsaveLoader = false;
      });
  }
});

export const { setToolsPlugin, setToolsName, setUserManagement, setErrorAlert } = configurationSlice.actions;

export default configurationSlice.reducer;
